import { FC } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const BlankSlate: FC = () => (
  <Box width="full">
    <Box flexWrap="wrap" alignItems="center" gap="s12">
      <Box flexDirection="row" paddingTop="s48">
        <Icon.Large icon="document-folder-drawer-2" color="grey600" />
      </Box>
      <Box flexDirection="row">
        <Text.Normal weight="bold" color="grey1000">
          {i18n.t('insights.blank_slate.title')}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" paddingBottom="s96">
        <Text.Normal size="200" color="grey800">
          {i18n.t('insights.blank_slate.description')}
        </Text.Normal>
      </Box>
    </Box>
  </Box>
)

export default BlankSlate
